import { atom } from 'nanostores'

export const $isCloseButtonVisible = atom(false)

function showCloseButton() {
  $isCloseButtonVisible.set(true)
}

function hideCloseButton() {
  $isCloseButtonVisible.set(false)
}

export const closeButton = {
  show: showCloseButton,
  hide: hideCloseButton,
}
